/**
 * Component that allows components to be hidden or shown based on whether a
 * a user has the desired role and/or permissions
 */
import PropTypes from 'prop-types';

const propTypes = {
  userPerms: PropTypes.arrayOf(PropTypes.string),
  userRoles: PropTypes.arrayOf(PropTypes.string),
  perms: PropTypes.arrayOf(PropTypes.string),
  roles: PropTypes.arrayOf(PropTypes.string),
  render: PropTypes.func,
  show: PropTypes.bool,
};

const defaultProps = {
  userPerms: null,
  userRoles: null,
  perms: null,
  roles: null,
  show: true,
  render: null,
};

function Authorized({ userPerms, userRoles, perms, roles, render, show, children }) {
  const hasPerm = !perms || (userPerms && perms.some((val) => userPerms.includes(val)));
  const hasRole = !roles || (userRoles && roles.some((val) => userRoles.includes(val)));
  const shouldShow = (hasRole && hasPerm && show) || ((!hasRole || !hasPerm) && !show);

  if (shouldShow) {
    return render ? render() : children;
  }

  return null;
}

Authorized.propTypes = propTypes;
Authorized.defaultProps = defaultProps;

export default Authorized;
